// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3Fa0u","select":"Header_select__ccNj1","clinic":"Header_clinic__1oDux"};